import * as yup from "yup";

export const jobTypeSchema = yup.object().shape({
  name: yup.string().required().label("Name"),
});
